export default class SettingsController {
  /* @ngInject */
  constructor($scope, $state, localStorageService, $translate) {
    this.$state = $state;
    this.localStorageService = localStorageService;
    this.$translate = $translate;

    // Prerequisites
    this.language = this.localStorageService.get('localeToUse') || 'de_DE';
  }

  /**
   * Language switch
   * @return {Void}
   */
  languageSwitch() {
    // Switch language
    this.$translate.use(this.language);

    // Store in localStorage
    this.localStorageService.add('localeToUse', this.language);
  }

}



/** WEBPACK FOOTER **
 ** ./src/app/components/settings/settings.controller.js
 **/